import React from "react";

import * as styles from "./chat-avatar.css";

interface ChatAvatarProps {
  username: string;
  profilePicture?: string;
  isOnline?: boolean;
  className?: string;
  profilePictureClassName?: string;
  placeholderClassName?: string;
  "data-testid"?: string;
}

export const ChatAvatar: React.FC<ChatAvatarProps> = ({
  username,
  profilePicture,
  isOnline = false,
  className,
  profilePictureClassName,
  placeholderClassName,
  "data-testid": dataTestId = "chat-avatar"
}) => {
  return (
    <div className={className || styles.avatar} data-testid={dataTestId}>
      {profilePicture ? (
        <img
          src={profilePicture}
          alt={username}
          className={profilePictureClassName || styles.profilePicture}
          data-testid={`${dataTestId}-profile-picture`}
        />
      ) : (
        <div
          className={placeholderClassName || styles.placeholder}
          data-testid={`${dataTestId}-placeholder`}
        >
          {username.charAt(0).toUpperCase()}
        </div>
      )}
      {isOnline && (
        <div
          className={styles.onlineIndicator}
          data-testid={`${dataTestId}-online`}
        />
      )}
    </div>
  );
};

export default ChatAvatar;
